import { clientFromFlags, type GlobalFlags } from '../context.js';
import { printJson } from '../redact.js';
import { EXIT, fields, out, style, symbols } from '../ui.js';

export async function pingCommand(flags: GlobalFlags): Promise<number> {
  const client = clientFromFlags(flags);
  const result = await client.ping();

  if (flags.json === true) {
    printJson(result);
    return EXIT.OK;
  }

  out(
    `${symbols.ok()} Connected to ${style.cyan(result.baseUrl)}  ${style.dim(
      `(${String(result.latencyMs)} ms)`,
    )}`,
  );

  const { granted, denied } = result.scopes;
  const rows: [string, string][] = [
    ['Token', `${style.bold(result.tokenPrefix)}${style.dim('••••••••')}`],
    [
      'Scopes',
      granted.length > 0
        ? style.green(granted.join(', '))
        : style.yellow('none granted'),
    ],
  ];

  if (denied.length > 0) {
    rows.push(['Missing', style.dim(denied.join(', '))]);
  }

  out(fields(rows));

  if (granted.length === 0) {
    out();
    out(
      style.dim(
        '  This token carries no usable scope. Regenerate it at\n' +
          '  https://app.gpmpay.com/api-tokens with the scopes you need.',
      ),
    );
  }

  return EXIT.OK;
}
